import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute.js';

import LoginPage from '../../features/auth/pages/login/LoginPage.js';
import AutomationResultPage from '../../features/automation/aiAutomation/AutomationResultPage.js';
import BillPage from '../../features/orders/billing/BillPage.js';
import DetailViewPage from '../../features/orders/ordering/pages/detail/DetailViewPage.js';
import OrdersListPage from '../../features/orders/ordering/pages/list/OrdersListPage.js';
import OperationPage from '../../features/orders/ordering/pages/workflow/OperationPage.js';
import ProductionCreatePage from '../../features/automation/videoEditing/pages/create/ProductionCreatePage.js';
import ProductionJobsPage from '../../features/automation/videoEditing/pages/jobs/ProductionJobsPage.js';
import JianyingCreatePage from '../../features/automation/jianying/pages/create/JianyingCreatePage.js';
import JianyingJobsPage from '../../features/automation/jianying/pages/jobs/JianyingJobsPage.js';
import {
  PRODUCTION_AUTOMATION_ROLE_IDS,
} from '../../features/automation/utils/productionAccess.js';
import SystemManagementPage from '../../features/systemManagement/layout/SystemManagementPage.js';
import { SYSTEM_MANAGEMENT_ROUTES } from '../../features/systemManagement/routes/systemManagementRouteRegistry.js';
import { DEFAULT_SYSTEM_MANAGEMENT_PATH } from '../../features/systemManagement/routes/systemManagementNavigation.js';


const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
   
    <Route path="/" element={<PrivateRoute element={OrdersListPage} />} />

    <Route path="/clients" element={<PrivateRoute element={OrdersListPage} />} />
    <Route path="/bills" element={<PrivateRoute element={BillPage} />} />
  
    <Route
      path=":status_id/create/:step_id"
      element={<PrivateRoute element={OperationPage} />}
    />
    <Route
      path=":status_id/:client_id"
      element={<PrivateRoute element={OperationPage} />}
    />
    <Route
      path="review/:client_id"
      element={<PrivateRoute element={DetailViewPage} />}
    />
    <Route
      path="/startWorkFlow/:workFlowStatus/:client_id"
      element={<PrivateRoute element={OperationPage} />}
    />
    <Route
      path="/automation-task-result/:client_id"
      element={<PrivateRoute element={AutomationResultPage} />}
    />

    <Route
      path="/automation/video-editing/list"
      element={(
        <PrivateRoute
          allowedRoles={PRODUCTION_AUTOMATION_ROLE_IDS}
          element={ProductionJobsPage}
        />
      )}
    />
    <Route
      path="/automation/video-editing/create"
      element={(
        <PrivateRoute
          allowedRoles={PRODUCTION_AUTOMATION_ROLE_IDS}
          element={ProductionCreatePage}
        />
      )}
    />
    <Route
      path="/automation/jianying/list"
      element={(
        <PrivateRoute
          allowedRoles={PRODUCTION_AUTOMATION_ROLE_IDS}
          element={JianyingJobsPage}
        />
      )}
    />
    <Route
      path="/automation/jianying/create"
      element={(
        <PrivateRoute
          allowedRoles={PRODUCTION_AUTOMATION_ROLE_IDS}
          element={JianyingCreatePage}
        />
      )}
    />

    <Route
      path="/system-management"
      element={<PrivateRoute element={SystemManagementPage} />}
    >
      {SYSTEM_MANAGEMENT_ROUTES.map(({ group, section, path, Component }) => (
        <Route
          key={path || `${group}/${section}`}
          path={path || `${group}/${section}`}
          element={<Component />}
        />
      ))}
      <Route index element={<Navigate to={DEFAULT_SYSTEM_MANAGEMENT_PATH} replace />} />
      <Route
        path="*"
        element={<Navigate to={DEFAULT_SYSTEM_MANAGEMENT_PATH} replace />}
      />
    </Route>

    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default AppRoutes;
